import { useEffect } from 'react'

const INVOICE_PRINT_VIEW_CLASS = 'invoice-print-view'

export const useInvoicePrintScope = () => {
  useEffect(() => {
    document.documentElement.classList.add(INVOICE_PRINT_VIEW_CLASS)

    return () => {
      document.documentElement.classList.remove(INVOICE_PRINT_VIEW_CLASS)
    }
  }, [])
}
